<template>
    <div class="cs">
        <div class="cs__header">
            <span class="cs__title">Activity</span>
            <span class="cs__count" v-if="comments.length">{{ comments.length }}</span>
        </div>
        <div class="cs__composer">
            <CommentForm @inserted="handeInsert" :taskId="taskId" />
        </div>
        <div class="cs__list">
            <div v-if="loading" class="cs__loading">
                <i class="fas fa-spinner fa-spin"></i> Loading comments...
            </div>
            <template v-else-if="comments.length">
                <CommentItem
                    :taskId="taskId"
                    :comment="comment"
                    v-for="comment of comments"
                    :key="comment.id"
                    :task="task"
                    @update="handleUpdate"
                    @remove="handleRemove"
                />
            </template>
            <div v-else class="cs__empty">
                <i class="far fa-comment-dots"></i>
                <span>No comments yet. Be the first to comment!</span>
            </div>
        </div>
    </div>
</template>

<script>
import HtmlEditor from "@/components/other/HtmlEditor"
import Button from "@/components/UI/Button"
import AttachmentUploader from "@/components/other/AttachmentUploader"
import CommentItem from "@/components/Lists/CommentItem"
import CommentForm from "@/components/Lists/CommentForm"
import { http } from "@/utils/http"

export default {
    data() {
        return {
            showCommentInput: false,
            comment: "",
            comments: [],
            loading: false,
            processingForm: false,
            removeFilesList: [],
            attachment1: null,
            attachment2: null,
            attachment3: null,
            attachment1Name: "",
            attachment2Name: "",
            attachment3Name: "",
            showAttachmentManager: true,
            task: null,
        }
    },
    props: { taskId: { type: [String, Number], default: "" } },
    components: { CommentItem, HtmlEditor, CommentForm, Button, AttachmentUploader },
    mounted() {
        this.fetchComments()
    },
    methods: {
        async fetchComments() {
            this.loading = true
            try {
                const res = await http.get("/project-comments?task_id=" + this.taskId)
                this.comments = res.data.result
                this.task = res.data.task
            } catch (err) {
                console.log("error in fetching comments", err)
            }
            this.loading = false
        },
        async handleRemove(comment) {
            this.comments = this.comments.filter((item) => item.id != comment.id)
        },
        async handeInsert(result) {
            this.comments = [result, ...this.comments]
        },
        handleUpdate(comment) {
            this.comments = this.comments.map((item) => {
                if (item.id == comment.id) {
                    item = comment
                }
                return item
            })
        },
    },
}
</script>

<style lang="scss" scoped>
@import "../../assets/variables.scss";

.cs {
    &__header {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 14px 18px;
        border-bottom: 1px solid $gray100;
    }
    &__title {
        font-size: 14px;
        font-weight: 700;
        color: $gray800;
    }
    &__count {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 22px;
        height: 22px;
        padding: 0 6px;
        border-radius: 12px;
        background: $primaryLight;
        color: $primaryColor;
        font-size: 11px;
        font-weight: 700;
    }
    &__composer {
        padding: 16px 18px;
        border-bottom: 1px solid $gray100;
    }
    &__list {
        padding: 0;
    }
    &__loading {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 28px 18px;
        color: $gray400;
        font-size: 13px;
        i { color: $primaryColor; }
    }
    &__empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 32px 18px;
        color: $gray400;
        font-size: 13px;
        i { font-size: 24px; color: $gray300; }
    }
}
</style>
